import { type ReactNode } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import type { ButtonProps } from 'react-bootstrap';

export interface SubmitButtonProps {
    children: ReactNode;
    loading?: boolean;
    disabled?: boolean;
    variant?: ButtonProps['variant'];
    size?: ButtonProps['size'];
    className?: string;
    type?: 'submit' | 'button';
    onClick?: () => void;
}

export function SubmitButton({
    children,
    loading,
    disabled,
    variant = 'primary',
    size,
    className,
    type = 'submit',
    onClick,
}: SubmitButtonProps) {
    return (
        <Button
            type={type}
            variant={variant}
            size={size}
            className={className}
            disabled={disabled || loading}
            onClick={onClick}
        >
            {loading && (
                <Spinner
                    as="span"
                    size="sm"
                    animation="border"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                />
            )}
            {children}
        </Button>
    );
}
